<template>
    <div class="switcheroo">
        <img @click="imageClick" src="../../assets/images/bars.svg" :class="{active: !state}">
        <label class="switch">
            <input @change="changeChart" ref="switcherbtn" type="checkbox" v-model="state">
            <span class="slider round"></span>
        </label>
        <img @click="imageClick" src="../../assets/images/line.svg" :class="{active: state}">
    </div>
</template>

<script>
export default {
  name: 'ChartSwitcher',
  data() {
    return {
      state: false,
    };
  },
  props: {
    currentState: {
      type: Number,
      required: false,
    },
  },
  mounted() {
    if (this.currentState !== undefined) {
      switch (this.currentState) {
        case 1:
          this.state = true;
          break;
        case 0:
          this.state = false;
          break;
        default:
          break;
      }
    }
  },
  methods: {
    changeChart() {
      this.$emit('changeChart');
    },
    imageClick() {
      this.state = !this.state;
      this.changeChart();
    },
  },
};
</script>

<style lang="scss" scoped>

    .switcheroo {
        align-items: center;
        display: flex;

        img {
            padding: 20px;
            cursor: pointer;
            filter: grayscale(100%);

            &.active {
                filter: none;
            }
        }
    }

    .switch {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 17px;
    }

    /* Hide default HTML checkbox */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #9e9e9e;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 17px;
        width: 30px;
        left: 1px;
        /*bottom: 4px;*/
        background-color: $marine-blue;
        -webkit-transition: .4s;
        transition: .4s;
    }

    input:checked + .slider {
        background-color: #9e9e9e;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #9e9e9e;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(30px);
        -ms-transform: translateX(30px);
        transform: translateX(30px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 30px;
    }

    .slider.round:before {
        border-radius: 30px;
    }

</style>
